import { BestOfWoltResponse } from './types';
import merchantGatewayApi from '../api';

export const fetchBestOfWolt = ({ venue_id, month, year }: { venue_id: string; month: number; year: number }) =>
  merchantGatewayApi
    .get<BestOfWoltResponse>(`/merchant-analytics-api/bow/venues/${venue_id}/tracking`, {
      params: { month, year },
    })
    .then(response => response.data);
